import Joi from "joi-browser";

function errorsAsString(errors) {
    let err = errors[0];
    switch (err.type) {
        case "string.alphanum":
            return "Must be alphabets and numbers";
        case "any.empty":
        case "any.required":
            return "can't be an empty field.";
        case "string.regex.base":
            return "invalid data";
    }
}

const ContactSupport = Joi.object().keys({
    email: Joi.string()
        .regex(/^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/)
        .required()
        .label("Email")
        .error((errors) => {
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(errors),
                },
            };
        }),
    phoneNumber: Joi.string()
        .regex(/^[0-9]+$/)
        .optional()
        .label("Phone Number")
        .error((errors) => {
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(errors),
                },
            };
        }),
    platform: Joi.required()
        .label("Platform")
        .error((errors) => {
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(errors),
                },
            };
        }),
    operatingSystem: Joi.when(Joi.ref("$showOS"), {
        is: true,
        then: Joi.string()
            .required()
            .label("Operating System")
            .error((errors) => {
                return {
                    template: " {{message}}",
                    context: {
                        errors: errors.length,
                        message: errorsAsString(errors),
                    },
                };
            }),
    }),
    issueType: Joi.required()
        .label("Category")
        .error((errors) => {
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(errors),
                },
            };
        }),
    issueDescription: Joi.string()
        .required()
        .label("Description")
        .error((errors) => {
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(errors),
                },
            };
        }),
});

export default { ContactSupport };
